/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { DirtyType } from '@gh/common-shared-data';
import { arrayOf, entity, enumeration, subentity } from '@gh/core-data';
import { UomQuantityMapper } from '../../common';
import { FormulaMapper } from '../../common/formula.mapper';
import { GtoUom } from '../../take-off-params/top.dto';
import {
  ComponentPropagateFormulaRequestCustomDto,
  ComponentPropagateFormulaRequestDto,
  HpeCcOrderDetailsDto,
  HpeComponentDto,
  HpeCostCenterItemRefDto,
  HpeCostCenterRefDto,
  HpeDetailsDto,
  HpeDetailsInitDto,
  HpeDetailsSaveRequestComponentDto,
  HpeDetailsSaveRequestCostCenterDto,
  HpeDetailsSaveRequestDto,
  HpeDetailsSaveRequestItemDto,
  HpeDetailsSaveRequestTopDto,
  HpeGenerateItemIdsResponseDto,
  HpeGetComponentsResponseDto,
  HpeGetCostCenterRequestComponentDto,
  HpeGetCostCenterRequestDto,
  HpeGetCostCenterRequestItemDto,
  HpeGetCostCenterRequestTopDto,
  HpeGetCostCenterResponseDto,
  HpeGetCostCenterResponseItemDto,
  HpeInitType,
  HpeTopRefItemDto,
  HpeViewMode,
} from '../models/hpe-details.dto';

export const HpeDetailsInitMapper = entity<HpeDetailsInitDto>({
  initType: enumeration(HpeInitType),
});

export const HpeDetailsMapper = entity<HpeDetailsDto>({
  viewMode: enumeration(HpeViewMode),
  hpComponents: arrayOf(subentity<HpeComponentDto>({
    formula: FormulaMapper,
  })),
  hpCostCenters: arrayOf(subentity<HpeCostCenterRefDto>({
    items: arrayOf(subentity<HpeCostCenterItemRefDto>({
      formula: FormulaMapper,
    })),
  })),
  tops: arrayOf(subentity<HpeTopRefItemDto>({
    gtoUom: enumeration(GtoUom),
  })),
});

export const HpeDetailsSaveMapper = entity<HpeDetailsSaveRequestDto>({
  hpCostCenters: arrayOf(subentity<HpeDetailsSaveRequestCostCenterDto>({
    dirtyType: enumeration(DirtyType),
  })),
  hpComponents: arrayOf(subentity<HpeDetailsSaveRequestComponentDto>({
    formula: FormulaMapper,
    dirtyType: enumeration(DirtyType),
  })),
  hpItems: arrayOf(subentity<HpeDetailsSaveRequestItemDto>({
    formula: FormulaMapper,
    dirtyType: enumeration(DirtyType),
  })),
  hpTops: arrayOf(subentity<HpeDetailsSaveRequestTopDto>({
    value: UomQuantityMapper,
  })),
});

export const HpeGetCostCenterRequestMapper = entity<HpeGetCostCenterRequestDto>({
  hpCostCenters: arrayOf(subentity<HpeDetailsSaveRequestCostCenterDto>({
    dirtyType: enumeration(DirtyType),
  })),
  hpComponents: arrayOf(subentity<HpeGetCostCenterRequestComponentDto>({
    formula: FormulaMapper,
    dirtyType: enumeration(DirtyType),
  })),
  hpItems: arrayOf(subentity<HpeGetCostCenterRequestItemDto>({
    formula: FormulaMapper,
    dirtyType: enumeration(DirtyType),
  })),
  hpTops: arrayOf(subentity<HpeGetCostCenterRequestTopDto>({
    value: UomQuantityMapper,
    dirtyType: enumeration(DirtyType),
  })),
});

export const HpeGetCostCenterResponseMapper = entity<HpeGetCostCenterResponseDto>({
  items: arrayOf(subentity<HpeGetCostCenterResponseItemDto>({
    formula: FormulaMapper,
  })),
});

export const HpeGetComponentsResponseMapper = entity<HpeGetComponentsResponseDto>({
  components: arrayOf(subentity<HpeComponentDto>({
    formula: FormulaMapper,
  })),
});

export const HpeCcOrderDetailsMapper = entity<HpeCcOrderDetailsDto>({});

export const HpeGenerateItemIdsResponseMapper = entity<HpeGenerateItemIdsResponseDto>({});

export const ComponentPropagateFormulaMapper = entity<ComponentPropagateFormulaRequestCustomDto>({});

export const ComponentPropagateFormulaRequestMapper = entity<ComponentPropagateFormulaRequestDto>({
  newFormula: FormulaMapper,
  oldFormula: FormulaMapper,
});
